var React = require('react');

function CalendarIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2F3642","fillRule":"evenodd","d":"M17,5 L18,5 C19.1045695,5 20,5.8954305 20,7 L20,17 C20,18.1045695 19.1045695,19 18,19 L6,19 C4.8954305,19 4,18.1045695 4,17 L4,7 C4,5.8954305 4.8954305,5 6,5 L7,5 L7,4 C7,3.44771525 7.44771525,3 8,3 C8.55228475,3 9,3.44771525 9,4 L9,5 L15,5 L15,4 C15,3.44771525 15.4477153,3 16,3 C16.5522847,3 17,3.44771525 17,4 L17,5 Z M18,9 L6,9 L6,17 L18,17 L18,9 Z M16,16 C15.4477153,16 15,15.5522847 15,15 C15,14.4477153 15.4477153,14 16,14 C16.5522847,14 17,14.4477153 17,15 C17,15.5522847 16.5522847,16 16,16 Z"}));
}

CalendarIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CalendarIcon;

CalendarIcon.default = CalendarIcon;
